const ApiPaths = {
  CHECK_PERMISSION: '/h5-proxy/checkpermission',
  SAVE_TRACKING: '/h5-proxy/savetrackingaction',
};
const Actions = {
  ENTER: 'enter',
  LOGIN: 'login',
  CASHIER: 'cashier',
  MAP_BANK: 'mapbank',
  TOPUP: 'topup',
  UPDATE_KYC: 'upgradekyc',
  BINDING: 'binding',
  GG_BINDING: 'gg_binding',
  ERROR: 'error'
};
const SESSION_KEYS = {
  H5_SESSION_DATA: 'h5datafromquerystring',
};
export {
  ApiPaths,
  Actions,
  SESSION_KEYS
};
